import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=d097ebcc&scoped=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=js"
export * from "./CollectionDetail.vue?vue&type=script&lang=js"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=d097ebcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d097ebcc",
  null
  
)

export default component.exports